import styled from 'styled-components';
import { colors } from '../../variables';

const TableFooter = styled.footer`
	background: #fff;
	padding: 20px;
	border: 1px solid ${colors.grey.normal};
	border-top: none;
`;

export default TableFooter;



// WEBPACK FOOTER //
// ./src/components/Common/Table/TableFooter.js